<template>
  <div>
    <component :is="componentName" :data="data"></component>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    componentName: '',
    data: {}
  }),
  components: {
    Nova: () => import('@/pages/Nova'),
    PageNotFound: () => import('@/views/PageNotFound')
  },
  created () {
    this.getInfo()
  },
  methods: {
    getInfo: async function () {
      try {
        this.data = (await axios.get(`/api${this.$route.path}`)).data
        if (this.data.error !== undefined) {
          this.showError('Такая запись не существует')
        } else {
          this.componentName = 'Nova'
        }
      } catch (e) {
        this.showError('Произошла непредвиденная ошибка')
      }
    },
    showError: function (message) {
      this.data = { message }
      this.componentName = 'PageNotFound'
    }
  }
}
</script>
